var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.60002 2.39978C2.88002 2.39978 2.40002 2.87978 2.40002 3.59978V20.3998C2.40002 21.1198 2.88002 21.5998 3.60002 21.5998H20.4C21.12 21.5998 21.6 21.1198 21.6 20.3998V3.59978C21.6 2.87978 21.12 2.39978 20.4 2.39978H3.60002ZM20.28 3.71978H3.72002V20.1598H20.16V3.71978H20.28Z",
    fill: "#8E97A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88003 5.99976H11.88C12.24 5.99976 12.48 6.35976 12.48 6.71976C12.48 7.07976 12.24 7.43976 11.88 7.43976H5.88003C5.52003 7.43976 5.28003 7.07976 5.28003 6.71976C5.28003 6.23976 5.52003 5.99976 5.88003 5.99976Z",
    fill: "#8E97A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88003 9.59973H11.88C12.24 9.59973 12.48 9.95973 12.48 10.3197C12.48 10.6797 12.24 11.0397 11.88 11.0397H5.88003C5.52003 11.0397 5.28003 10.6797 5.28003 10.3197C5.28003 9.83973 5.52003 9.59973 5.88003 9.59973Z",
    fill: "#8E97A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88003 13.1997H11.88C12.24 13.1997 12.48 13.5597 12.48 13.9197C12.48 14.2797 12.24 14.6397 11.88 14.6397H5.88003C5.52003 14.6397 5.28003 14.2797 5.28003 13.9197C5.28003 13.4397 5.52003 13.1997 5.88003 13.1997Z",
    fill: "#8E97A3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88003 16.6798H11.88C12.24 16.6798 12.48 17.0398 12.48 17.3998C12.48 17.7598 12.24 18.1198 11.88 18.1198H5.88003C5.52003 18.1198 5.28003 17.7598 5.28003 17.3998C5.28003 16.9198 5.52003 16.6798 5.88003 16.6798Z",
    fill: "#8E97A3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16.3197C17.76 16.3197 17.64 16.1997 17.52 16.0797L13.92 12.4797C13.68 12.2397 13.68 11.7597 13.92 11.5197L17.52 7.91975C17.76 7.67975 18.24 7.67975 18.48 7.91975C18.72 8.15975 18.72 8.63975 18.48 8.87975L15.36 11.9997L18.48 15.1197C18.72 15.3597 18.72 15.8397 18.48 16.0797C18.36 16.1997 18.24 16.3197 18 16.3197Z",
    fill: "#8E97A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarClose);
export default __webpack_public_path__ + "static/media/sidebar-close.a1a234f5996c42542bf53de8fd5125fa.svg";
export { ForwardRef as ReactComponent };